<label class="dynamic-form-item-label">
    {{prefix}}
</label>
<div [ngSwitch]="templateType" class={{payload?.cssClass}}>
    <ng-container *ngSwitchCase="'MULTILINKS'">
        <span class="left-bracket">(</span>
        <a *ngFor="let link of payload; let i = index" (click)="updateLink(i)" [href]="link?.address" target="_blank" class="Auto_link-{{link?.text}} ">{{link.text}} </a>
        <span class="right-bracket">)</span>
    </ng-container>
    <ng-container *ngSwitchCase="'WARNING'">
        <span class="icon__warning" *ngIf="payload?.showWarningIcon" genTooltip
              [tooltipPosition]="payload?.tooltipPosition || 'BOTTOM'"
              [tooltipText]="payload?.tooltipText"
              [tooltipHtml]="payload?.tooltipHtml"
              [tooltipShow]="payload?.tooltipShow"
              [tooltipConfiguration]="payload?.tooltipConfiguration"></span>
    </ng-container>
    <ng-container *ngSwitchCase="'INFO'">
        <span class="pi pi-info-circle" genTooltip
              [tooltipPosition]="payload?.tooltipPosition || 'BOTTOM'"
              [tooltipText]="payload?.tooltipText"
              [tooltipHtml]="payload?.tooltipHtml"
              [tooltipShow]="payload?.tooltipShow"
              [tooltipConfiguration]="payload?.tooltipConfiguration"></span>
    </ng-container>
</div>
